
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
} from 'vue'
import { accountTypeOptions, statusOptions } from './config'
import { useTableScroll } from '@/common/mixins/useTableScroll'
import { delPackage, getList } from './request'
import { UsePageDto } from '@/common/mixins/listPageDto'
import { useStore } from 'vuex'
import formatDate from '@/common/functions/formatDate'
import { message, Modal } from 'ant-design-vue'
import Add from './components/Add.vue'
import handleStartTime from 'library/functions/handleStartTime'
import handleEndTime from 'library/functions/handleEndTime'

export default defineComponent({
    components: {
        Add,
    },
    setup() {
        let filter = reactive({
            type: null,
            status: null,
            name: '',
            timeRange: null,
        })
        let data = ref([])
        let loading = ref(false)
        const store = useStore()
        const instance = getCurrentInstance()
        const { scroll } = useTableScroll(instance)

        const { pagination, listPageDto, handleTableChange, refresh } =
            UsePageDto(instance)
        const columns = [
            {
                title: '名称',
                dataIndex: 'name',
                key: 'name',
                width: 150,
            },
            {
                title: '是否是应用功能包',
                key: 'isAppPkg',
                slots: { customRender: 'isAppPkg' },
                width: 150,
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                width: 150,
            },
            {
                title: '所属系统',
                dataIndex: 'systemName',
                key: 'systemName',
                width: 150,
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                slots: { customRender: 'createTime' },
                key: 'createTime',
                width: 170,
            },
            {
                title: '操作',
                dataIndex: 'action',
                slots: { customRender: 'action' },
                key: 'action',
                width: 120,
            },
        ]
        // 获取列表
        const fetchList = async () => {
            const params = {
                name: filter.name || null,
                type: filter.type || null,
                status: filter.status || null,
                pageDto: {
                    pageNum: listPageDto.pageNum,
                    pageSize: listPageDto.pageSize,
                },
            }
            let timeRange: any = filter.timeRange
            if (timeRange) {
                Object.assign(params, {
                    startTime: handleStartTime(new Date(timeRange[0])),
                    endTime: handleEndTime(new Date(timeRange[1])),
                })
            }
            loading.value = true
            try {
                const res = await getList(params)
                loading.value = false
                data.value = res.data
                Object.assign(listPageDto, res.pageDto)
            } catch (e) {
                loading.value = false
            }
        }
        function modAction(record: any) {
            store.commit('togglePackageAddState', true)
            store.commit('setPackageDetail', record)
        }
        async function delAction(record: any) {
            try {
                const params = {
                    packageId: record.id,
                }
                loading.value = true
                await delPackage(params)
                loading.value = false
                message.success('删除功能包成功')
                fetchList()
            } catch (error) {
                loading.value = false
                console.log(error)
            }
        }
        function addAction() {
            store.commit('togglePackageAddState', true)
        }

        onMounted(() => {
            fetchList()
        })
        return {
            data,
            columns,
            store,
            scroll,
            formatDate,
            loading,
            filter,
            fetchList,
            modAction,
            pagination,
            refresh,
            statusOptions,
            addAction,
            accountTypeOptions,
            handleTableChange,
            delAction,
        }
    },
})
